// extracted by mini-css-extract-plugin
export default {"iconCheck":"CompletePage-module__iconCheck--5TGW7"};